module.exports = __webpack_public_path__ + "static/media/foodshot20.f01b2d42.JPG";